/* BONEZ 独自ヘッダー：スクロール切替 ＋ メニュードロワー ＋ スクロール演出 */
(function () {
  function initHeader() {
    var hdr = document.getElementById('bonez-hdr');
    if (hdr && !hdr.dataset.init) {
      hdr.dataset.init = '1';
      if (hdr.dataset.home === 'true') {
        var onScroll = function () {
          if (window.scrollY > window.innerHeight * 0.8) hdr.classList.add('is-scrolled');
          else hdr.classList.remove('is-scrolled');
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        onScroll();
      }
    }
    var drawer = document.getElementById('bonez-drawer');
    if (drawer && !drawer.dataset.init) {
      drawer.dataset.init = '1';
      var open = function () {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('bonez-drawer-open');
      };
      var close = function () {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('bonez-drawer-open');
      };
      document.querySelectorAll('[data-drawer-open]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); open(); });
      });
      drawer.querySelectorAll('[data-drawer-close]').forEach(function (b) {
        b.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }
  }

  function initReveal() {
    var mobile = window.matchMedia('(max-width:749px)').matches;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!mobile || reduce || !document.body.classList.contains('template-index')) return;
    document.documentElement.classList.add('bonez-anim');
    var sel = '.bonez-prow-head,.bonez-prow__copy,.bonez-prow__media,.bonez-news__head,.bonez-news__item,.bonez-guide__h,.bonez-guide__card';
    var els = [].slice.call(document.querySelectorAll(sel)).filter(function (el) { return !el.dataset.rvObs; });
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.dataset.rvObs = '1'; el.classList.add('is-rv'); }); return; }
    var io = window.__bonezRVio || (window.__bonezRVio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-rv'); window.__bonezRVio.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }));
    els.forEach(function (el) { el.dataset.rvObs = '1'; io.observe(el); });
    [['.bonez-news__list', '.bonez-news__item'], ['.bonez-guide__grid', '.bonez-guide__card']].forEach(function (p) {
      document.querySelectorAll(p[0]).forEach(function (group) {
        var k = 0;
        [].slice.call(group.children).forEach(function (child) {
          if (child.matches && child.matches(p[1])) { child.style.transitionDelay = ((k % 4) * 0.08) + 's'; k++; }
        });
      });
    });
  }

  function run() { initHeader(); initReveal(); }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();
